// action - state management
import { AUTH_ACTIONS } from 'config';

export function setLogin(payload) {
  return {
    type: AUTH_ACTIONS.LOGIN,
    payload
  };
}

export function updateStatus(payload) {
  return {
    type: AUTH_ACTIONS.UPDATE_STATUS,
    payload
  };
}

export function updatePermission(payload) {
  return {
    type: AUTH_ACTIONS.UPDATE_PERMISSION,
    payload
  };
}

export function setPermission(payload) {
  return {
    type: AUTH_ACTIONS.SET_PERMISSION,
    payload
  };
}

export function setLogout() {
  return {
    type: AUTH_ACTIONS.LOGOUT
  };
}

export function setCurrentUser(payload) {
  return {
    type: AUTH_ACTIONS.SET_CURRENT_USER,
    payload
  };
}

export function updateDatabase(payload) {
  return {
    type: AUTH_ACTIONS.UPDATE_DATABASE,
    payload
  };
}
